import * as actionTypes from '../actions/actionTypes';
import { updateObject } from 'helpers/Utility';

const initialState = {
  messageModel: '',
  paymentInquiry: '',
  statusPayment: '',
  paymentStatus: localStorage.getItem('paymentStatus')
    ? localStorage.getItem('paymentStatus')
    : '',
  paymentTransac: '',
  lastPayment: localStorage.getItem('lastPayment')
    ? localStorage.getItem('lastPayment')
    : '',
  resInquiryLoanPayment: null,
  resInquiryLoanPaymentStatus: null,
  paidOffLifeTime: Number(localStorage.getItem('paidOffLifeTime') || 0)
};

const setFetchMessage = (state, action) => {
  return updateObject(state, { messageModel: action.data });
};

const setPaymentInquiry = (state, action) => {
  return updateObject(state, {
    paymentInquiry: action.data,
    statusPayment: action.status
  });
};

const setPaymentTrasaction = (state, action) => {
  return updateObject(state, { paymentTransac: action.data });
};

const setPaymentStatus = (state, action) => {
  localStorage.setItem('paymentStatus', action.val);
  return updateObject(state, { paymentStatus: action.val });
};

const setLastPayment = (state, action) => {
  localStorage.setItem('lastPayment', action.val);
  return updateObject(state, { lastPayment: action.val });
};

const setInquiryLoanPayment = (state, action) => {
  return updateObject(state, { resInquiryLoanPayment: action.res });
};

const setInquiryLoanPaymentStatus = (state, action) => {
  localStorage.setItem('paidOffLifeTime', action.res?.paidOffLifetime);

  return updateObject(state, {
    resInquiryLoanPaymentStatus: action.res,
    paidOffLifeTime: action.res?.paidOffLifetime
  });
};

const setSubtractionPaidOffLifeTime = state => {
  let paidOffLifeTime;

  if (state.paidOffLifeTime <= 0) paidOffLifeTime = 0;
  else paidOffLifeTime = state.paidOffLifeTime - 1;

  localStorage.setItem('paidOffLifeTime', paidOffLifeTime);
  return updateObject(state, { paidOffLifeTime: paidOffLifeTime });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FECT_MESSAGE_PAYMENT:
      return setFetchMessage(state, action);
    case actionTypes.PAYMENT_INQUIRY:
      return setPaymentInquiry(state, action);
    case actionTypes.PAYMENT_TRANSACTION:
      return setPaymentTrasaction(state, action);
    case actionTypes.STATUS_PAYMENT:
      return setPaymentStatus(state, action);
    case actionTypes.LAST_PAYMENT:
      return setLastPayment(state, action);
    case actionTypes.SET_INQUIRY_LOAN_PAYMENT:
      return setInquiryLoanPayment(state, action);
    case actionTypes.SET_INQUIRY_LOAN_PAYMENT_STATUS:
      return setInquiryLoanPaymentStatus(state, action);
    case actionTypes.SUBTRACTION_PAID_OFF_LIFE_TIME:
      return setSubtractionPaidOffLifeTime(state);
    default:
      return state;
  }
};

export default reducer;
